import { render, staticRenderFns } from "./CommonEducationBrandsBlock.vue?vue&type=template&id=3b762c1c&scoped=true&"
import script from "./CommonEducationBrandsBlock.vue?vue&type=script&lang=ts&"
export * from "./CommonEducationBrandsBlock.vue?vue&type=script&lang=ts&"
import style0 from "./CommonEducationBrandsBlock.vue?vue&type=style&index=0&id=3b762c1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b762c1c",
  null
  
)

export default component.exports